module.exports = __webpack_public_path__ + "static/media/getting-support-large@2x.85c76820.png";